import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withKeys as _withKeys, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8aba281c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"display":"flex","height":"100%","flex-direction":"column","padding":"0 16px 16px"}
}
const _hoisted_2 = {
  class: "",
  style: {"padding":"20px","height":"100%","box-sizing":"border-box"}
}
const _hoisted_3 = {
  class: "cm-align-center gap-5",
  style: {"margin":"0px 8px","display":"flex","flex-wrap":"wrap","justify-items":"start","overflow-y":"auto","max-height":"180px","padding":"10px"}
}
const _hoisted_4 = {
  class: "el-card tags-is-error",
  style: {"padding":"10px"}
}
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_6 = {
  key: 0,
  style: {"padding-right":"70px","color":"var(--el-text-color-regular)"}
}
const _hoisted_7 = {
  class: "el-card",
  style: {"background-color":"var(--cm-color-card-bg)","flex":"1"}
}
const _hoisted_8 = { style: {"max-height":"200px"} }
const _hoisted_9 = {
  class: "cm-align-center",
  style: {"margin":"0px 8px","display":"grid","gap":"5px","grid-template-columns":"repeat(10,1fr)","align-content":"stretch","justify-content":"center","justify-items":"start","grid-auto-flow":"row","overflow-y":"auto","max-height":"180px","padding":"4px 3px"}
}

import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { computed, nextTick, onMounted, PropType, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import {
  ActionType,
  FormActionType,
  FormItem,
  FormSize,
  FormSizeType,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import {
  DataTypeSensitive,
  DataTypeSensitiveText,
  EditSensitiveWordsRequestParamsForm,
  ExcludeEditSensitiveWordsRequestParams,
  SensitiveStateType,
} from '../types/sensitive-file-scanning'
import Keywords from './Keywords.vue'
import { ElMessageBox } from 'element-plus'
import { ElMessage } from 'element-plus'
import {
  EditSensitiveWordsRequestParams,
  GetSensitiveWordsResultsRequestParamsDataRow,
  PostSensitiveWordsModifiedStateRequestParams,
  SensitiveWordsListData,
  SensitiveWordsListRequestParams,
} from '../service'
import FileTypeItem from './FileTypeItem.vue'
import { useRouter } from 'vue-router'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { SensitiveService } from '../service'
import { listCol } from '@/utils/list-columns-i18n'
import { MAX_LENGTH } from '@/utils/tool'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'scanning-config',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  hasPermission: {
    type: Boolean,
    default: false,
  },
  needToNav: {
    type: Boolean,
    default: true,
  },
  detailInfo: {
    type: Object as PropType<GetSensitiveWordsResultsRequestParamsDataRow>,
    required: false,
    default: () => ({} as GetSensitiveWordsResultsRequestParamsDataRow),
  },
},
  emits: ['update:modelValue','refresh'],
  setup(__props, { emit: __emit }) {

const props = __props
// 注入服务
const injector = useReflectiveInjector([SensitiveService])
const sensitiveService = injector.get(SensitiveService)
// API 方法
const getSensitiveWordsListApi = sensitiveService.getSensitiveWordsList.bind(sensitiveService)
const delSensitiveWordsApi = sensitiveService.delSensitiveWords.bind(sensitiveService)
const postSensitiveWordsModifiedState = sensitiveService.postSensitiveWordsModifiedState.bind(sensitiveService)
const editSensitiveWordsApi = sensitiveService.postSensitiveWords.bind(sensitiveService)
const getSensitiveWordsFileExtApi = sensitiveService.getSensitiveWordsFileExt.bind(sensitiveService)
const reg = /^\.[a-zA-Z0-9]+$/

const data = ref([] as { type: number, data: string[] }[])
const dataList = computed(() => data.value.map(item => item.data).flat(1))
const checkAll = ref(true)
const emits = __emit
const getLs = computed(() => tag => reg.test(tag))
const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emits('update:modelValue', val)
  },
})
const validateKeywords = (rule, value, callback) => {
  if (value.some((item) => item.length > 20)) {
    callback(new Error(t('sensitiveFileScanning.tagMaxLength', {count: 20})))
  } else if (value) {
    if (value.length > 20) {
      callback(new Error(t('sensitiveFileScanning.sensitiveWordMaxCount')))
    }
  }
  callback()
}
const validateExtsKeywords = (rule, value: string[], callback) => {
  form.value.custom_exts.forEach(item => {
    if (!reg.test(item)) {
      callback(new Error(t('sensitiveFileScanning.customExtFormat')))
    }
  })
  value.forEach(ext => {
    if (form.value.custom_exts.includes(ext)) {
      callback(new Error(t('sensitiveFileScanning.customExtNoDuplicate')))
    }
  })

  callback()
}
const router = useRouter()
const queryParams = ref<SensitiveWordsListRequestParams>()
const formRef = ref()
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const formSize: FormSizeType = FormSize.Small
const form = ref<Partial<EditSensitiveWordsRequestParams>>({
  keywords: [],
  custom_exts: [],
  exts: [],
  id: undefined,
  description: '',
  data_type: DataTypeSensitive.Customize,
})
const disabled = ref(false)
const status = ref(1)
const multiWords = ref('')
const multiExts = ref('')
const disabledStatus = ref(false)
const { t, locale } = useI18n()
const statusTextKeys = { 1: 'statusView', 2: 'statusEdit', 3: 'statusAdd' } as const
const statusTitle = computed(() => {
  void locale.value
  return locale.value === 'ja-JP'? t('sensitiveFileScanning.sensitiveWordSuffix')+t('sensitiveFileScanning.' + statusTextKeys[status.value]): t('sensitiveFileScanning.' + statusTextKeys[status.value]) + t('sensitiveFileScanning.sensitiveWordSuffix')
})
const visibleForm = ref(false)
const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    isLink: true,
    height: '100%',
    columnOpt: { label: listCol(t, 'operation'), width: 100, align: 'left', fixed: 'right' },
    actionButtons: ({ data_type }) => [
      {
        name: t('sensitiveFileScanning.' + ([
            DataTypeSensitive.EmployeeInformation,
            DataTypeSensitive.FinancialBudget,
            DataTypeSensitive.SalaryBonus,
            DataTypeSensitive.TechnicalSolution,
          ].includes(data_type) ? 'viewSensitiveWord' : 'editSensitiveWord')),
        type: ActionType.Edit,
        opt: { size: 'small', icon: '', type: 'primary' },
      },
      {
        name: t('sensitiveFileScanning.deleteSensitiveWord'),
        outSource: true,
        disabled: () => data_type !== 1,
        type: ActionType.Delete,
        opt: { size: FormSize.Small, type: 'danger' },
      },
    ],
  }
})
const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: 'padding: 0',
    showActionBar: true,
    showForm: true,
    showRightToolbar: false,
    height: '100%',
    showTip: false,
    rowKey: 'id',
    selection: false,
    path: 'data',
    columns: [
      {
        label: t('sensitiveFileScanning.type'),
        prop: 'data_type',
        formatter: (row, val) =>
          val === DataTypeSensitive.Customize
            ? row.name
            : t(DataTypeSensitiveText[val]),
        minWidth: 160,
      },
      { label: t('sensitiveFileScanning.enableState'), prop: 'state', minWidth: 100 },
      { label: t('sensitiveFileScanning.sensitiveWord'), prop: 'keywords', minWidth: 350 },
      { label: t('sensitiveFileScanning.fileFormatScan'), prop: 'exts', minWidth: 260 },
      { label: t('sensitiveFileScanning.description'), prop: 'description', minWidth: 180, showOverflow: true },
    ],
  }
})
const menuLeftBtns = computed(() => {
  void locale.value
  return [
    {
      type: ActionType.Add,
      name: t('sensitiveFileScanning.customSensitiveWord'),
      opt: { type: 'primary', size: FormSize.Small },
    },
  ]
})
const formColumns = computed<
  ObjectFormItem<
    EditSensitiveWordsRequestParamsForm,
    ExcludeEditSensitiveWordsRequestParams
  >
>(() => {
  void locale.value
  return {
  name: {
    label: t('sensitiveFileScanning.type'),
    disabled: () => disabledStatus.value,
    colOpt: { span: 24 },
    inputOpt: { maxlength: MAX_LENGTH },
    required: true,
  },
  description: {
    label: t('sensitiveFileScanning.description'),
    colOpt: { span: 24 },
    inputOpt: { maxlength: 50 },
    disabled: () => disabledStatus.value,
  },
  keywords: {
    label: t('sensitiveFileScanning.sensitiveWord'),
    colOpt: { span: 24 },
    disabled: () => disabledStatus.value,
    slot: true,
    rules: [{ custom: { validator: validateKeywords } }],
    required: true,
    placeholder: t('sensitiveFileScanning.keywordsPlaceholder'),
    inputType: 'textarea',
    inputOpt: { rows: 15, autosize: { minRows: 6, maxRows: 7 } },
  },
  exts: {
    label: t('sensitiveFileScanning.fileFormatScan'),
    colOpt: { span: 24 },
    disabled: () => disabledStatus.value,
    slot: true,
    rules: [{ custom: { validator: validateExtsKeywords } }],
    required: !(form.value.custom_exts?.length || form.value.exts?.length),
    placeholder: t('sensitiveFileScanning.extsPlaceholder'),
    inputType: 'textarea',
    inputOpt: { rows: 15, autosize: { minRows: 6, maxRows: 7 } },
  },
  }
})
const handleReset = async () => {
  multiWords.value = ''
  multiExts.value = ''
  form.value = {
    custom_exts: [],
    id: undefined,
    keywords: [],
    exts: [],
    name: '',
    description: '',
    data_type: DataTypeSensitive.Customize,
  }
  formRef.value.ruleFormRef?.resetFields?.()
}
const handleClose = () => {
  handleReset()
}
const handleBlurExts = (prop) => {
  handleAddExtsTags(prop)
}
const handleBlurKeywords = (prop) => {
  handleAddTags(prop)
}
const handleSubmit: (
  valid: boolean,
  done: () => void,
) => Promise<void> = async (
  valid: boolean,
  done: (ok: boolean, message?: string, normalClick?: boolean) => void,
) => {
    if (status.value === 1) {
      visibleForm.value = false
      done(false, '', true)
      return
    }
    if (!valid) return
    // api
    const result = await editSensitiveWordsApi({
      ...form.value,
      state: !form.value.id ? SensitiveStateType.Allowed : form.value.state,
    }).catch(err => console.log('err', err))
    const ok = result?.resp_common?.msg === 'ok'
    done(ok)
    if(!ok)return;
    // 暂时隐藏
    // if (!form.value.id && props.needToNav) {
    //   ElMessageBox.confirm(
    //   `<p style="margin-bottom: 10px;">${t('sensitiveFileScanning.createPolicyAfterAdd')}</p>`,
    //   t('sensitiveFileScanning.tip'),
    //   {
    //     dangerouslyUseHTMLString: true,
    //     confirmButtonText: t('sensitiveFileScanning.createPolicy'),
    //     cancelButtonText: t('sensitiveFileScanning.notNow'),
    //   }
    // )
    //   .then(async () => {
    //     router.push('/dashboard/file-control-strategy-setting?name='+form.value.name)
    //   }).catch(() => {
    //     visibleForm.value = !ok
    //   })
    // }else{
    //   visibleForm.value = !ok
    // }
    void refreshList()
    emits('refresh')
  }
const handleAction = ({
  type,
  rowItem,
}: {
  type: string
  rowItem?: SensitiveWordsListData
}) => {
  const types = {
    [ActionType.Add]: async () => {
      visibleForm.value = true
      disabledStatus.value = false
      checkAll.value = true
      status.value = 3
    },
    [ActionType.Edit]: async () => {
      visibleForm.value = true
      checkAll.value = false
      const flag = [
        DataTypeSensitive.FinancialBudget,
        DataTypeSensitive.SalaryBonus,
        DataTypeSensitive.EmployeeInformation,
        DataTypeSensitive.TechnicalSolution,
      ].includes(rowItem.data_type)
      disabledStatus.value = flag
      status.value = flag
        ? SensitiveStateType.Allowed
        : SensitiveStateType.Rejected
      form.value = { ...rowItem }
      form.value.id = !flag ? rowItem.id : undefined
      rowItem.data_type !== DataTypeSensitive.Customize &&
        (form.value.name = t(DataTypeSensitiveText[rowItem.data_type]))
    },
    [ActionType.Revert]: async () => {
      rowItem.state = rowItem.state == 1 ? 2 : 1
      ElMessageBox.confirm(
        rowItem.state === 2 ? t('sensitiveFileScanning.confirmDisableSensitiveWord') : t('sensitiveFileScanning.confirmEnableSensitiveWord'),
        t('sensitiveFileScanning.tip'),
        {
          confirmButtonText: t('sensitiveFileScanning.confirm'),
          cancelButtonText: t('sensitiveFileScanning.cancel'),
        },
      )
        .then(async () => {
          if (!~~rowItem.id) {
            delete rowItem.id
            await editSensitiveWordsApi(rowItem)
          } else {
            await postSensitiveWordsModifiedState({
              id: rowItem.id,
              state: rowItem.state,
            })
          }
          void refreshList()
          emits('refresh')
          ElMessage.success(t('sensitiveFileScanning.operationSuccess'))
        })
        .catch(async () => {
          rowItem.state = rowItem.state == 1 ? 2 : 1
        })
    },
  }
  types[type]?.()
}
watch(() => visibleForm.value, (nv) => {
  if (!nv) {
    handleReset()
  }
})
watch(
  () => [form.value.exts, form.value.custom_exts],
  async () => {
    await nextTick()
    if (form.value.custom_exts?.length || form.value.exts?.length) {
      formRef.value?.ruleFormRef?.clearValidate?.('exts')
    }
  },
  { deep: true },
)
const handleCloseTag = (index, prop) => {
  form.value[prop].splice(index, 1,)
  formRef?.value.ruleFormRef?.validateField?.(prop)
}
const handleAddTags = (prop) => {
  form.value[prop].push(
    ...multiWords.value
      .split(/[,，、;；]/)
      .filter((item) => !!item.trim())
      .map((item) => item.trimEnd().trimStart())
  )
  multiWords.value = ''
  form.value[prop] = [...new Set(form.value[prop])]
  formRef.value.ruleFormRef.validateField(prop)
}
const handleCloseExtsTag = (index, prop) => {
  form.value[prop].splice(index, 1,)
  formRef.value.ruleFormRef.validateField('exts')
}
const handleAddExtsTags = async (prop) => {
  form.value[prop].push(
    ...multiExts.value
      .split(/[,，、;；]/)
      .filter((item) => !!item.trim())
      .map((item) => item.trimEnd().trimStart()),
  )
  multiExts.value = ''
  form.value[prop] = [...new Set(form.value[prop])]
  formRef.value.ruleFormRef.validateField('exts')
}
const validateExts = () => {
  formRef.value.ruleFormRef?.validateField?.('exts')
}
const getExtList = async () => {
  const result = await getSensitiveWordsFileExtApi()
  data.value = result.data
}
onMounted(() => {
  getExtList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((visible).value = $event)),
    title: _ctx.$t('sensitiveFileScanning.sensitiveWordConfigTitle'),
    size: "75%",
    direction: "rtl",
    style: {"height":"100%","box-sizing":"border-box"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CmTable, {
          tableOpt: tableOpt.value,
          "del-api": _unref(delSensitiveWordsApi),
          deleteMessageCallback: () =>
        _ctx.$t('sensitiveFileScanning.deleteSensitiveWordTip')
        ,
          api: _unref(getSensitiveWordsListApi),
          onHandleAction: handleAction,
          modelValue: queryParams.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams).value = $event)),
          cardOpt: { style: { height: '100%', border: 'none' } },
          ref_key: "tableRef",
          ref: tableRef,
          pageOption: { pageNumName: 'page', pageSizeName: 'limit' },
          menuLeftBtns: menuLeftBtns.value,
          tableActOpt: tableActOpt.value,
          firstLoading: true
        }, {
          keywords: _withCtx(({ value }) => [
            _createVNode(Keywords, {
              "max-count": 3,
              keywords: value
            }, null, 8, ["keywords"])
          ]),
          exts: _withCtx(({ value, row }) => [
            _createVNode(Keywords, {
              "max-count": 3,
              keywords: [...value, ...row.custom_exts]
            }, null, 8, ["keywords"])
          ]),
          state: _withCtx(({ row }) => [
            _createVNode(_component_el_switch, {
              "model-value": row.state,
              onClick: ($event: any) => (handleAction({ type: _unref(ActionType).Revert, rowItem: row })),
              "active-value": 1,
              "inactive-value": 2,
              style: {"--el-switch-on-color":"var(--cm-color-primary)"}
            }, null, 8, ["model-value", "onClick"])
          ]),
          _: 1
        }, 8, ["tableOpt", "del-api", "deleteMessageCallback", "api", "modelValue", "menuLeftBtns", "tableActOpt"]),
        _createVNode(_component_el_drawer, {
          modelValue: visibleForm.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visibleForm).value = $event)),
          size: "55%",
          onClose: handleClose,
          title: statusTitle.value,
          direction: "rtl",
          style: {"height":"100%","box-sizing":"border-box"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(CmForm, {
                style: {"display":"flex","flex-direction":"column","height":"100%","justify-content":"space-between"},
                rowOpt: { style: 'overflow:auto' },
                opeRowOpt: { justify: 'start' },
                formSize: _unref(formSize),
                disabled: disabled.value,
                "onUpdate:disabled": _cache[5] || (_cache[5] = ($event: any) => ((disabled).value = $event)),
                modelValue: form.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form).value = $event)),
                ref_key: "formRef",
                ref: formRef,
                onSubmit: handleSubmit,
                onReset: _cache[7] || (_cache[7] = () => {
              handleReset()
              visibleForm.value = false
            }
              ),
                formOpt: { 'label-width': 'auto', labelPosition: 'left' },
                actionColOpt: {
                style: 'display:flex;justify-content:flex-start',
                span: 24,
              },
                formColumns: formColumns.value
              }, {
                keywords: _withCtx(({ formItem, prop }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(!disabledStatus.value && 'el-card tags-is-error'),
                    style: {"background-color":"var(--cm-color-card-bg)"}
                  }, [
                    _withDirectives(_createElementVNode("div", {
                      style: {"max-height":"200px"},
                      class: _normalizeClass(disabledStatus.value && 'el-card')
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value[prop], (tag, index) => {
                          return (_openBlock(), _createBlock(_component_el_tag, {
                            key: tag,
                            style: {"word-break":"break-all","max-width":"200px","width":"auto"},
                            title: tag,
                            closable: !disabledStatus.value,
                            type: tag.length > 10 ? 'danger' : 'primary',
                            round: true,
                            size: "small",
                            onClose: ($event: any) => (handleCloseTag(index, prop))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.slice(0, 20) + (tag.length > 20 ? '...' : '')), 1)
                            ]),
                            _: 2
                          }, 1032, ["title", "closable", "type", "onClose"]))
                        }), 128))
                      ])
                    ], 2), [
                      [_vShow, form.value[prop].length]
                    ]),
                    (!disabledStatus.value)
                      ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                          key: 0,
                          class: "tags",
                          style: {"border":"none"},
                          modelValue: multiWords.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((multiWords).value = $event)),
                          modelModifiers: { trim: true },
                          onKeyup: _withKeys(($event: any) => (handleAddTags(prop)), ["enter"]),
                          size: "small",
                          onBlur: ($event: any) => (handleBlurKeywords(prop))
                        }, formItem.inputOpt, {
                          type: formItem.inputType,
                          placeholder: formItem.placeholder
                        }), null, 16, ["modelValue", "onKeyup", "onBlur", "type", "placeholder"]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                exts: _withCtx(({ formItem, prop }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(FileTypeItem, {
                      visible: visibleForm.value,
                      list: data.value,
                      "check-all": checkAll.value,
                      modelValue: form.value[prop],
                      "onUpdate:modelValue": ($event: any) => ((form.value[prop]) = $event),
                      disabled: disabledStatus.value
                    }, {
                      default: _withCtx(() => [
                        (!disabledStatus.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (!_unref(IS_JP_ONLY_BUILD))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('sensitiveFileScanning.customType')), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.custom_exts, (tag, index) => {
                                      return (_openBlock(), _createBlock(_component_el_tag, {
                                        key: tag + index,
                                        style: {"word-break":"break-all","max-width":"200px"},
                                        title: tag,
                                        closable: !disabledStatus.value,
                                        type: (tag.length <= 10 && !dataList.value.includes(tag) && getLs.value(tag)) ? 'primary' : 'danger',
                                        round: true,
                                        size: "small",
                                        onClose: ($event: any) => (handleCloseExtsTag(index, 'custom_exts'))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(tag.slice(0, 20) + (tag.length > 20 ? '...' : '')), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["title", "closable", "type", "onClose"]))
                                    }), 128))
                                  ])
                                ], 512), [
                                  [_vShow, form.value['custom_exts'].length]
                                ]),
                                _createVNode(_component_el_input, _mergeProps({
                                  class: "tags",
                                  style: {"border":"none"},
                                  modelValue: multiExts.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((multiExts).value = $event)),
                                  modelModifiers: { trim: true },
                                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (handleBlurExts('custom_exts'))),
                                  onFocus: validateExts,
                                  onChange: validateExts,
                                  onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (handleAddExtsTags('custom_exts')), ["enter"])),
                                  size: "small"
                                }, formItem.inputOpt, {
                                  type: formItem.inputType,
                                  placeholder: formItem.placeholder
                                }), null, 16, ["modelValue", "type", "placeholder"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["visible", "list", "check-all", "modelValue", "onUpdate:modelValue", "disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["formSize", "disabled", "modelValue", "formColumns"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})